import { render, staticRenderFns } from "./BackgroundForm.vue?vue&type=template&id=4163aa8c"
import script from "./BackgroundForm.vue?vue&type=script&lang=js"
export * from "./BackgroundForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports